import { ApiResponseModel, ApiVisa, BaseApiTemplateService, Core2Config } from "../../../shared";
import { TemplateMessageLineContainerModel } from "../../../../../../../models/aggregates/alg/cc/template-message";
import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";

@Injectable({ providedIn: 'root' })
export class TemplateMessageLineService extends BaseApiTemplateService<TemplateMessageLineContainerModel>{
  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ALG_CC_MODULE + 'template-messages-lines';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ALG_CC_MODULE + 'template-messages-lines';
    this.httpClient = http;
  }

  deleteFile(fileGuid, visa: ApiVisa) {
    const url = this.apiUrl + '/delete-file/' + fileGuid;
    return this.httpClient.delete(url, this.getHttpHeader(visa))
  }

  putMultiLines(dtoObject: TemplateMessageLineContainerModel[], visa: ApiVisa) {
    let url = this.apiUrl + '/multi';
    if (this.endpoint_path && visa.api_domain_url) {
      url = visa.api_domain_url + this.endpoint_path + '/multi';
    }
    return this.httpClient.put<ApiResponseModel<TemplateMessageLineContainerModel[]>>(url, dtoObject, this.getHttpHeader(visa));
  }


  postMultiLines(dtoObject: TemplateMessageLineContainerModel[], visa: ApiVisa) {
    let url = this.apiUrl + '/multi';
    if (this.endpoint_path && visa.api_domain_url) {
      url = visa.api_domain_url + this.endpoint_path + '/multi';
    }
    return this.httpClient.post<ApiResponseModel<TemplateMessageLineContainerModel[]>>(url, dtoObject, this.getHttpHeader(visa));
  }


  getFile(guid, visa: ApiVisa) {
    let url = this.apiUrl + '/file/' + guid;
    if (this.endpoint_path && visa.api_domain_url) {
      url = visa.api_domain_url + this.endpoint_path + '/file/' + guid;
    }
    return this.httpClient.get<Blob>(url, this.getHttpHeaderBlob(visa));
  }
  getAwsUrl(guid, visa: ApiVisa) {
    let url = this.apiUrl + '/file-url/' + guid;
    if (this.endpoint_path && visa.api_domain_url) {
      url = visa.api_domain_url + this.endpoint_path + '/file-url/' + guid;
    }
    return this.httpClient.get<any>(url, this.getHttpHeader(visa));
  }

}
